import $axios from "@/plugins/axioslib";
import appconfig from "@/appconfig";

const state = {
  httpStatusText: ""
};

const getters = {
  userProfile: (state: any) => state,
  httpStatusText: (state: any) => state.httpStatusText
};

const actions = {
  async updatePassword({ commit }: any, data: any) {
    const url = appconfig.audience + "/api/users/password";
    await $axios
      .put(url, data)
      .then(response => {
        if (response.status == 200) {
          commit("setObject", {
            key: "httpStatusText",
            data: "success"
          });
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response.status == 400 && err.response.data == "OldPassword") {
          commit("setObject", {
            key: "httpStatusText",
            data: err.response.data
          });
        } else {
          commit("setObject", {
            key: "httpStatusText",
            data: err.response.status
          });
        }
        return Promise.resolve();
      });
  }
};

const mutations = {
  setObject: (state: any, object: any) => {
    const { key, data } = object;
    state[key] = data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
